import storage from 'good-storage'

export function isLogin() {
	var token = getToken()
	// console.log("token"+token)
	return token?true:false
}

export function setToken(token) {
	localStorage.setItem("token",token)
	// storage.session.set("token",token);
}

export function getToken() {
	// return storage.session.get("token");
    return	localStorage.getItem('token')
}
